// ---------------------------------------------------------------------------
// CSS Sanitizer — Publish-Time Defense-in-Depth
// ---------------------------------------------------------------------------
// Strips confirmed CSS execution vectors from custom CSS strings.
// Runs silently at publish time — never throws, never rejects.
// The Zod schema (pageSettingsSchema) is the user-facing validation gate.
// This sanitizer is the backstop for pre-existing records and edge cases.

const CSS_DANGEROUS_PATTERNS: ReadonlyArray<RegExp> = [
  /@import\b/gi,
  /\bexpression\s*\(/gi,
  /-moz-binding\s*:/gi,
  /behavior\s*:/gi,
  /url\s*\(\s*["']?\s*javascript\s*:/gi,
  /url\s*\(\s*["']?\s*data:\s*text\/html/gi,
];

/**
 * Strip dangerous CSS patterns from a custom CSS string.
 * Never throws — returns the sanitized CSS.
 * Does NOT block url() for safe resources (fonts, images) —
 * that's the Zod schema's job at save time.
 */
export function sanitizeCss(css: string): string {
  let result = css;
  for (const pattern of CSS_DANGEROUS_PATTERNS) {
    result = result.replace(new RegExp(pattern.source, pattern.flags), "");
  }
  return result;
}

// Exported for testing
export { CSS_DANGEROUS_PATTERNS };
